import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { Observable } from 'rxjs';
import { InspecaoImpressaoModel, InspecaoModeloImpressaoModel } from './models';
import { GetInspecaoModeloImpressaoDto, PostImprimirFichaDto } from './dto';

@Injectable()
export class InspecaoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverUrl, ApiResources.INSPECOES);
  }

  getModelosImpressao(
    params?: GetInspecaoModeloImpressaoDto,
  ): Observable<{ count: number; results: InspecaoModeloImpressaoModel[] }> {
    return this.customClient
      .get(`${this.basePath}/modelos-impressao`, params)
      .pipe(this.mapperData());
  }

  imprimirFicha(body: PostImprimirFichaDto): Observable<InspecaoImpressaoModel> {
    return this.customClient
      .post(`${this.basePath}/imprimir-ficha`, {
        CodigoInspecao: body.CodigoInspecao,
        CodigoInspecaoModeloImpressao: body.CodigoInspecaoModeloImpressao,
        TipoTemplateInspecao: body.TipoTemplateInspecao || 'P',
      })
      .pipe(this.mapperData());
  }
}
